import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import Header from './Header';
import Home from './Home';
import Home2 from './Home2';
import Services from './Services';
import ServiceDetails from './ServiceDetails';
import BookSession from './BookSession';
import SpecialistDetails from './SpecialistDetails';
import BookSpecialist from './BookSpecialist';
import TrainerDetails from './TrainerDetails';
import BookingConfirmation from './BookingConfirmation';
import MyBookings from './MyBookings';
import Trainings from './Trainings';
import About from './About';
import TermsAndConditions from './TermsAndConditions';
import SignUp from './SignUp';
import Login from './Login';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import ForgotPassword from './ForgotPassword';
import Profile from './Profile';
import BackgroundAudio from './BackgroundAudio';
import ChatWidget from './ChatWidget';
import { LanguageProvider } from './LanguageContext';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppContent() {
  const location = useLocation();
  const isAdminLoginPage = location.pathname === '/admin-login';
  const isAdminDashboard = location.pathname.startsWith('/admin-dashboard');
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Check if user is logged in
  useEffect(() => {
    const checkLoginStatus = () => {
      const loggedIn = localStorage.getItem('userLoggedIn') === 'true';
      setIsLoggedIn(loggedIn);
    };

    checkLoginStatus();
    // Listen for storage changes (in case user logs in/out in another tab)
    window.addEventListener('storage', checkLoginStatus);
    // Listen for custom login/logout events
    window.addEventListener('userLogin', checkLoginStatus);
    window.addEventListener('userLogout', checkLoginStatus);

    return () => {
      window.removeEventListener('storage', checkLoginStatus);
      window.removeEventListener('userLogin', checkLoginStatus);
      window.removeEventListener('userLogout', checkLoginStatus);
    };
  }, []);

  return (
    <>
      <ScrollToTop />
      {!isAdminLoginPage && !isAdminDashboard && <Header />}
      {!isAdminLoginPage && !isAdminDashboard && isLoggedIn && <ChatWidget />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home2" element={<Home2 />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:id" element={<ServiceDetails />} />
        <Route path="/book/:id" element={<BookSession />} />
        <Route path="/specialists/:id" element={<SpecialistDetails />} />
        <Route path="/book-specialist/:id" element={<BookSpecialist />} />
        <Route path="/trainers/:id" element={<TrainerDetails />} />
        <Route path="/booking-confirmation" element={<BookingConfirmation />} />
        <Route path="/my-bookings" element={<MyBookings />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/about" element={<About />} />
        <Route path="/trainings" element={<Trainings />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin-dashboard/*" element={<AdminDashboard />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
      </Routes>
    </>
  );
}

function App() {
  const paypalOptions = {
    "client-id": "AdTHSduIOq9bceFGJuOMR1SBKSpSq4y8Ul7Dcf_9mR6Tscx7tNujfrWwpucY2d4LMO41KtpQCcy3TwSk",
    currency: "USD",
    components: "buttons",
    intent: "capture"
  };

  return (
    <PayPalScriptProvider options={paypalOptions}>
      <BackgroundAudio />
      <Router>
        <LanguageProvider>
          <AppContent />
        </LanguageProvider>
      </Router>
    </PayPalScriptProvider>
  );
}

export default App;
